<template>
    <v-app id="inspire">
        <v-main>
            <v-container
                    class="fill-height"
                    fluid
            >
                <v-row
                        align="center"
                        justify="center"
                >
                    <v-col
                            cols="12"
                            md="4"
                            sm="8"
                    >
                        <v-card class="elevation-2">
                            <v-toolbar
                                    color="primary"
                                    dark
                                    flat
                            >
                                <v-toolbar-title>OS Admin</v-toolbar-title>

                            </v-toolbar>
                            <v-card-text>
                                <v-form>
                                    <v-combobox
                                            :items="items"
                                            label="Base URL"
                                            prepend-icon="fas fa-network-wired"
                                            v-model="selected"
                                    ></v-combobox>
                                    <v-text-field
                                            @keydown.enter="login"
                                            label="Benutzer"
                                            name="login"
                                            prepend-icon="fas fa-user-shield"
                                            type="text"
                                            v-model="username"
                                    />

                                    <v-text-field
                                            @keydown.enter="login"
                                            id="password"
                                            label="Passwort"
                                            name="password"
                                            prepend-icon="fas fa-key"
                                            type="password"
                                            v-model="password"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="login" color="blue darken-1" text>Anmelden</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-snackbar
                    multi-line
                    top
                    v-model="error"
            >
                <div class="red--text"></div>
                <br>
                <div>{{ text }}</div>

                <v-btn
                        @click="error = false"
                        color="red"
                        text>
                    Close
                </v-btn>
            </v-snackbar>

            <v-dialog
                    v-model="wait"
                    persistent
                    width="300"
            >
                <v-card
                        color="primary"
                        dark
                >
                    <v-card-text>
                        Bitte warten...
                        <v-progress-linear
                                indeterminate
                                color="white"
                                class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>

        </v-main>
    </v-app>
</template>

<script>
    import axios from 'axios';
    import {HTTP} from '../http';

    export default {
        methods: {
            toFormUrlEncoded(object) {
                return Object.entries(object)
                    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
                    .join('&');
            },
            login() {
                this.wait=true;
                const requestBody = {
                    grant_type: 'password',
                    username: this.username,
                    password: this.password
                };

                const config = {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };


                axios.post(this.selected + "Token", this.toFormUrlEncoded(requestBody), config).then(result => {
                    this.wait=false;
                    localStorage.ridtoken = result.data.access_token;
                    HTTP.defaults.headers.Authorization = 'Bearer ' + result.data.access_token;
                    HTTP.defaults.baseURL = this.selected;
                    localStorage.baseUrl = this.selected;

                    this.$router.push("/");
                }).catch(err => {
                    this.wait=false;
                    if (err.response == null) {
                        this.text = err.toString();
                    } else if (err.response.status === 400) {
                        this.text = "Passwort oder Benutzer falsh!"
                    } else {
                        this.text = err.toString();
                    }

                    this.error = true;
                })

            }
        },
        props: {
            source: String,
        },
        data: () => ({
            wait:false,
            items: ['https://testapi.optimussoftware.de/', 'http://localhost:50477/', 'https://licadminapi.optimussoftware.de/'],
            selected: 'https://licadminapi.optimussoftware.de/',
            username: null,
            password: null,
            error: false,
            text: ''
        }),
        mounted() {
            if (this.$route.query.baseUrl != null) {
                this.selected = this.$route.query.baseUrl;
            } else {
                if (localStorage.baseUrl) {
                    this.selected = localStorage.baseUrl;
                }

            }

        }
    }
</script>
